<div class="c-modal">
    <div mat-dialog-content class="c-modal__dialog" style="max-width:450px;">
        <div class="c-modal__header">
            <div class="o-grid">
                <div class="o-grid__cell u-no-p"></div>
                <div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
                    <button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
                        <i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
                        <span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="c-modal__content u-no-pt">
            <div class="o-grid" style="margin-top: 15px;">
                <div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.businessServiceSetting.enableActivationReminder">
                    <p class="c-text">
                        <span>{{ 'Employees.Send_Activation_Reminder_Info' | translate}}</span>
                        <item-info-popover [text]="('Employees.Reminder_Email_Content_Initial_Part' | translate) + ': ' + ('Employees.Reminder_Email_Content_Activation' | translate).replaceAll('%s1', vm.projectName)"
                                           placement="right"
                                           placementMobile="top"
                                           [wrapperMobile]="vm.popoverMobileWrapper"
                                           (click)="$event.preventDefault()"
                                           style="vertical-align:middle"
                                           class="u-osl-xs u-hidden@up-to-md">
                        </item-info-popover>
                    </p>
                </div>
            </div>
            <div class="o-grid" style="margin-top: 15px;">
                <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--left" *ngIf="vm.businessServiceSetting.enableActivationReminder" id="reinviteEmployeeButton">
                    <button (click)="vm.sendActivationEmployeeReminder()" class="c-button c-button--s1 c-button--fit">{{ 'Employees.Send_Activation_Reminder' | translate}}</button>
                </div>
            </div>
            <div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.activationEmailsSent" style="margin-top: 15px;">
                <p class="c-text c-text--success c-text--center">{{ 'Employees.Activation_Reminder_Emails_Are_Sent_Successfully' | translate }}</p>
            </div>
            <div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.errorActivationReminderNotEnabled" style="margin-top: 15px;">
                <p class="c-text c-text--s3 c-text--center">{{ 'Employees.Error_Activation_Reminder_Not_Enabled' | translate }}</p>
            </div>
            <div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.errorActivationReminderIntervalNotLeft" style="margin-top: 15px;">
                <p class="c-text c-text--s3 c-text--center">{{vm.errorActivationReminderIntervalNotLeftInfo}}</p>
            </div>
            <div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.errorActivationReminderNotAdminOrHr" style="margin-top: 15px;">
                <p class="c-text c-text--s3 c-text--center">{{ 'Employees.Error_Not_Admin_Or_Hr_For_Activation_Reminder' | translate }}</p>
            </div>
            <div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.errorSendingEmails" style="margin-top: 15px;">
                <p class="c-text c-text--s3 c-text--center">{{ 'Employees.Error_Sending_Emails' | translate }}</p>
            </div>
            <div class="o-grid" style="margin-top: 15px;" *ngIf="vm.businessServiceSetting.enableSessionLimitReminder && vm.isBusinessClient">
                <div class="o-grid__cell o-grid__cell--w-100">
                    <p class="c-text">
                        {{ 'Employees.Send_Session_Left_Reminder_Info' | translate}}
                        <item-info-popover [text]="('Employees.Reminder_Email_Content_Initial_Part' | translate) + ': ' + ('Employees.Reminder_Email_Content_Session_Balance' | translate).replaceAll('%s1', vm.projectName).replaceAll('%s0', vm.user.service.title)"
                                           placement="right"
                                           placementMobile="top"
                                           [wrapperMobile]="vm.popoverMobileWrapper"
                                           (click)="$event.preventDefault()"
                                           style="vertical-align:middle"
                                           class="u-osl-xs u-hidden@up-to-md">
                        </item-info-popover>
                    </p>
                </div>
            </div>
            <div class="o-grid" style="margin-top: 15px;">
                <div class="o-grid__cell o-grid__cell--w-100  o-grid__cell--left" *ngIf="vm.businessServiceSetting.enableSessionLimitReminder && vm.isBusinessClient" id="remindSessionLimitButton">
                    <button (click)="vm.sendSessionLimitReminder()"  class="c-button c-button--s1 c-button--fit">{{ 'Employees.Send_Session_Limit_Reminder' | translate}}</button>
                </div>
            </div>
            <div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.sessionLimitEmailsSent" style="margin-top: 15px;">
                <p class="c-text c-text--success c-text--center">{{ 'Employees.Session_Limit_Reminder_Emails_Are_Sent_Successfully' | translate }}</p>
            </div>
            <div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.errorSessionLimitReminderNotEnabled" style="margin-top: 15px;">
                <p class="c-text c-text--s3 c-text--center">{{ 'Employees.Error_Session_Limit_Reminder_Not_Enabled' | translate }}</p>
            </div>
            <div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.errorSessionLimitReminderIntervalNotLeft" style="margin-top: 15px;">
                <p class="c-text c-text--s3 c-text--center">{{ vm.errorSessionLimitReminderIntervalNotLeftInfo}}</p>
            </div>
            <div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.errorSessionLimitReminderNotAdminOrHr" style="margin-top: 15px;">
                <p class="c-text c-text--s3 c-text--center">{{ 'Employees.Error_Not_Admin_Or_Hr_For_Session_Left_Reminder' | translate }}</p>
            </div>
            <div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.errorSendingEmails" style="margin-top: 15px;">
                <p class="c-text c-text--s3 c-text--center">{{ 'Employees.Error_Sending_Emails' | translate }}</p>
            </div>
        </div>
    </div>
</div>
